import styles from './UtilMenu.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React from 'react';

import { Navigation } from 'src/api/contentful/contentTypes.cloverdotcom';

import { LogoLink } from 'src/components/LogoLink/LogoLink';

import { componentKey, getField } from 'src/utils/EntryUtil';
import { UtilMenuItem } from './UtilMenuItem/UtilMenuItem';

export interface IUtilNav extends React.AllHTMLAttributes<HTMLDivElement> {
  entry?: ReferencedEntry<Navigation>;
  mobile?: boolean;
  children?: never;
}

export const UtilMenu: React.FC<IUtilNav> = ({
  entry, mobile, hidden, className, children, ...props
}) => {
  const items = getField(entry, 'items', []);

  return (
    <div
      className={cx(styles.utilWrapper, className)}
      aria-hidden={hidden ? true : undefined}
      {...props}
    >
      <nav className={styles.utilMenu}>
        <LogoLink tabIndex={hidden ? -1 : undefined} className={styles.logo} />
        {items.length > 0 && (
          <ul className={styles.menu}>
            {items.map((item, index) => <UtilMenuItem key={componentKey(item, index)} entry={item} mobile={mobile} hidden={hidden} />)}
          </ul>
        )}
      </nav>
    </div>
  );
};
